import { render, staticRenderFns } from "./ProductSubClassesTableModal.vue?vue&type=template&id=153caf9e"
import script from "./ProductSubClassesTableModal.vue?vue&type=script&lang=js"
export * from "./ProductSubClassesTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports